import { render, staticRenderFns } from "./Inadimplencia.vue?vue&type=template&id=43cb7dca&scoped=true"
import script from "./Inadimplencia.vue?vue&type=script&lang=js"
export * from "./Inadimplencia.vue?vue&type=script&lang=js"
import style0 from "./Inadimplencia.vue?vue&type=style&index=0&id=43cb7dca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43cb7dca",
  null
  
)

export default component.exports